import React, { Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/index.scss';
import './i18n/config'; // Configuration i18n
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ConditionalAdminAuthProvider } from './contexts/ConditionalAdminAuthProvider';
import { ThemeProvider } from './contexts/ThemeContext';

// Loading fallback component
const LoadingFallback = () => (
  <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
    <div className="text-center">
      <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Chargement...</span>
      </div>
      <p className="text-muted">Chargement de l'application...</p>
    </div>
  </div>
);

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <HelmetProvider>
        <BrowserRouter>
          <ThemeProvider>
            <AuthProvider>
              <ConditionalAdminAuthProvider>
                <App />
              </ConditionalAdminAuthProvider>
            </AuthProvider>
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Suspense>
  </React.StrictMode>
);

// Hydrate pre-rendered HTML when available (production build), otherwise client-render.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

